// @flow

import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { zIndexes, fontSize } from 'frontend_core/dist/styles/variables'

const Close = styled.span`
  display: inline-block;
  width: 16px;
  height: 16px;
  color: ${Colors.grayD};
  font-size: ${fontSize.medium}px;
`

const CloseWrapper = styled.a`
  display: inline-block;
  cursor: pointer;
  z-index: ${zIndexes.child};

  &:hover {
    ${Close} {
        color: ${Colors.grayB};
      }
    }
  }
`

type PropTypes = {
  onClick: Function,
}

export default (props: PropTypes) => (
  <CloseWrapper onClick={props.onClick}>
    <Close className="icon-spm-close" />
  </CloseWrapper>
)



// WEBPACK FOOTER //
// ./src/components/atoms/Close/index.jsx